import { Constants } from '@pwc/pwc-deals-web-common';
import {
  baseStyles,
  draggingOverBorder,
  draggingOverBorderError,
  draggingOverBackgroundColor,
} from './constants';

const isAreaFilled = (libraryItems) => {
  return libraryItems.length > 0;
};

const canLibraryItemBePlacedInSection = (
  libraryItemId,
  droppableLocationId,
  libraryItemMap
) => {
  const parsedLibraryItemId = Number.isInteger(parseInt(libraryItemId, 10))
    ? parseInt(libraryItemId, 10)
    : null;
  return !(
    parsedLibraryItemId &&
    libraryItemMap[parsedLibraryItemId] &&
    libraryItemMap[parsedLibraryItemId].type !==
      Constants.LIBRARY_ITEM_TYPES.RICH_TEXT.value &&
    droppableLocationId.includes('text-overflow')
  );
};

export const getStyle = (
  droppableSnapshot,
  droppableLocationId,
  popOver,
  libraryItemMap,
  libraryItems
) => {
  const { isDraggingOver, draggingOverWith, draggingFromThisWith } =
    droppableSnapshot;
  const returnedStyle = { ...baseStyles };
  if (popOver)
    return {
      border: 'var(--s2px) dashed var(--hovered-section-border-color)',
      borderRadius: 'var(--s2px)',
      backgroundColor: 'var(--dragdrop-container-background-hover)',
    };
  if (
    isAreaFilled(libraryItems) &&
    draggingOverWith &&
    draggingOverWith === draggingFromThisWith
  ) {
    Object.assign(returnedStyle, {
      border: draggingOverBorder,
      backgroundColor: draggingOverBackgroundColor,
      cursor: 'grab',
      // height: 'calc(var(--s25) * 4)'
    });
    return returnedStyle;
  }
  if (
    isAreaFilled(libraryItems) &&
    draggingOverWith &&
    !canLibraryItemBePlacedInSection(
      draggingOverWith,
      droppableLocationId,
      libraryItemMap
    )
  ) {
    Object.assign(returnedStyle, { border: draggingOverBorderError });
    return returnedStyle;
  }
  if (isAreaFilled(libraryItems)) {
    return {
      padding: 'var(--s2px)',
    };
  }
  if (
    !isAreaFilled(libraryItems) &&
    isDraggingOver &&
    draggingOverWith &&
    canLibraryItemBePlacedInSection(
      draggingOverWith,
      droppableLocationId,
      libraryItemMap
    )
  ) {
    Object.assign(returnedStyle, {
      border: draggingOverBorder,
      borderRadius: 'var(--s2px)',
      backgroundColor: draggingOverBackgroundColor,
      cursor: 'grab',
    });
    return returnedStyle;
  }
  if (
    !isAreaFilled(libraryItems) &&
    isDraggingOver &&
    draggingOverWith &&
    !canLibraryItemBePlacedInSection(
      draggingOverWith,
      droppableLocationId,
      libraryItemMap
    )
  ) {
    Object.assign(returnedStyle, {
      border: draggingOverBorderError,
    });
    return returnedStyle;
  }
  // return no styles if area is not filled and not being dragged over and allow scss to set the styles
  return {};
};
